import { useState } from "react";
import { motion, useScroll, useMotionValueEvent } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";

const links = [
  { id: "services", label: "Services" },
  { id: "story", label: "Our Story" },
  { id: "projects", label: "Projects" },
  { id: "process", label: "Process" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { scrollY } = useScroll();
  useMotionValueEvent(scrollY, "change", (v) => setScrolled(v > 40));

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color] duration-500 border-b ${
        scrolled || open ? "bg-[#F8F6F0]/85 backdrop-blur-xl border-[#E2DDD5]" : "bg-transparent border-transparent"
      }`}
      data-testid="site-header"
    >
      <div className="mx-auto flex h-[72px] max-w-[1400px] items-center justify-between px-5 sm:px-8 lg:px-12">
        <a href="#top" data-testid="header-logo-link" aria-label="James Family Home Improvement home"><Logo /></a>
        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <a key={l.id} href={`#${l.id}`} data-testid={`nav-link-${l.id}`}
              className="group relative text-sm font-medium text-[#1E1B18]">
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-full origin-left scale-x-0 bg-[#C85A32] transition-transform duration-500 group-hover:scale-x-100" />
            </a>
          ))}
          <a href="#quote" data-testid="header-quote-button"
            className="group inline-flex items-center gap-2 rounded-full bg-[#1E1B18] px-5 py-2.5 text-sm font-semibold text-[#F8F6F0] transition-colors duration-300 hover:bg-[#C85A32]">
            Free Quote <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
          </a>
        </nav>
        <button className="lg:hidden p-2" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Toggle menu">
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-[#E2DDD5] px-5 pb-8 pt-4" data-testid="mobile-menu">
          {links.map((l) => (
            <a key={l.id} href={`#${l.id}`} onClick={() => setOpen(false)} data-testid={`mobile-nav-link-${l.id}`}
              className="block py-3 font-serif-d text-3xl">{l.label}</a>
          ))}
          <a href="#quote" onClick={() => setOpen(false)} data-testid="mobile-quote-button"
            className="mt-4 inline-flex rounded-full bg-[#C85A32] px-6 py-3 text-sm font-semibold text-white">Request a Free Quote</a>
        </div>
      )}
    </motion.header>
  );
};
